angular.module('ihestiaCommonDirectives.tryEscapeHtml')
  .factory('ihestiaTryEscapeHtml', ['lsnTryEscapeHtml', function(lsnTryEscapeHtml) {
    return lsnTryEscapeHtml;
  }]);